const hasNewCasino = [
  "sys",
  "sysbet",
  "cartola",
  "homolog",
  "apostesempre",
  "pixsorte",
  "pixpremioesporte",
  "pingolbet",
  "podersports",
  "betdasorte",
  "radarbets",
  "jogodeourobet",
  "apostador",
  "overbets",
  "betinterativovip",
  "bets88",
  "pixbrasil",
  "betclub7",
  "betpremier",
  "8bets",
  "nbet91",
  "betnaveia",
  "imperialbetcom",
  "recpix",
  "viapix",
  "a3bet",
  "kbet",
  "betpix",
  "sportshowpix",
  "faz1bet",
  "bettoro",
  "sheik",
  "trevosports",
  "pixlive",
  "jogano",
  "donosdabola",
  "bet24hs",
  "betgol777",
  "amabet",
  "oxebet",
  "espetbet",
  "latano",
  "dubaibet",
  "18kbet",
  "18kbetonline",
  "plane",
  "nubet",
  "mandala",
  "betfolia",
  "sullbet",
  "confiancasports",
  "volpebet",
  "arenas",
  "chutaco",
  "betgol",
  "popbet",
  "deboa",
  "betzilla",
  "sbet355",
  "superbetsapp",
  "pokarbet",
  "bolladasorte",
  "betsuper",
  "bbsesportes",
  "pixbetbrasil",
  "betpag",
  "qgpix",
  "pagamaissports",
  "topsports",
  "apostamaster",
  "placarxbet",
  "sportsdarodada",
  "golacobet",
  "placarbets",
  "limasports",
  "esportenet",
  "bateubet",
  "attack",
  "streetbet",
  "lancebet",
  "cashbetbrasil",
  "sabiobet",
  "sys",
  "spinbet",
  "pixcerto",
  "betdosertao",
  "oficialbetgames",
  "caixabets",
  "soccer888",
  "g6games",
  "lotusbet",
  "nordestefutebol",
  "boto",
  "coraesportes",
  "aki",
  "elitexbetnet",
  "taky",
  "bellosports",
  "sportebet",
  "cuiababets"
];

export default hasNewCasino;
